// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f29a7c22","488":"7e1d6039"}[chunkId] + ".chunk.js";
};